import React from 'react';
import Grid from 'atoms/Layout/Grid/Grid';
import Stack from 'atoms/Layout/Stack/Stack';
import ResourceCategoriesMenu from 'molecules/ResourceCategoriesMenu/ResourceCategoriesMenu';
import { useResourceCategory } from 'app/templates/ResourceCategory/useResourceCategory';

const CategoryMenu = (): JSX.Element => {
  const { category, subCategory } = useResourceCategory();

  return (
    <Grid totalColumns={1}>
      <Stack>
        <ResourceCategoriesMenu
          preSetCategory={category}
          preSetSubCategory={subCategory}
        />
      </Stack>
    </Grid>
  );
};

export default CategoryMenu;
